export default {
  'product-recommendations:title': 'Al eens geprobeerd?',
};
